@if ((listSpec && selectRequestData)) {
  <lm-list #lmlookuplist
    [listUrlInfo]="listUrlInfo"
    [listSpec]="listSpec"
    [selectRequestData]="selectRequestData"
    (listRowSelected)="onRowsSelected($event)"
    [ngStyle]="{'width': '100%'}"
    [allowOverlayInteractions]="false"
    (titleChanged)="onTitleChanged($event)"
    (toolbarButtonEvent)="onToolbarButtonEvent($event)"
    (listDisplayed)="onListDisplayed()"
    >
  </lm-list>
}
